import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure38 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31','#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        bar: {
          dataLabels: {
              enabled: true
          }
      },
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
          categories: ["Pays les moins avancés (PMA)", "Pays en développement sans littoral (PDSL)", "Petits États insulaires en développement (PEID)", "", "Afrique subsaharienne", "Océanie", "Afrique du Nord et Asie de l’Ouest", "Amérique latine et Caraïbes", "Europe et Amérique du Nord", "Asie de l’Est et Asie du Sud-Est", "Asie centrale et du Sud", "", "Monde", ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          	format: '{value}',
          formatter: function () {
            // should be return this.value + '.00%'; but doesn't fit
            return this.value + '%';
        },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 80,
        min: 0,
        tickInterval: 20,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Agriculture',
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 0.3, 0.2, 0.2, null, 0.1, 1.3, 0.4, 0.3, 0.3, 1.2, 0.4, null, 0.6,],
      },
      {
        name: 'Total',
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[ 4.5, 3.3, 25.9, null, 13.1, 71.6, 11.5, 12.6, 51.6, 19.8, 3.0, null, 19.4,] 
      }
    ]
}